import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './workStyle.css';
import {useHistory} from "react-router-dom";


const WorkSection = () => {
    let history = useHistory();

    const empleos = useSelector((store) => store.oft.empleos);
    const [lista, setLista] = useState([]);


    useEffect(() => {
        if (empleos) {
            setLista(empleos);
        }
    }, [empleos]);

    return (
        <section id="works" className="works-area" style={{marginTop:'80px'}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 section-title">
                        <h2>
                            Ofertas de empleo
                        </h2>
                        <div className="bar"></div>
                    </div>
                    {lista.map((item) =>
                        <div className="col-12 job-card shadow-sm" onClick={() => {
                            history.push(`/empleo/${item.id_oferta_empleo}`)
                        }}>
                            <div className="job-logo">
                                <img src="assets/img/ISOTIPO.png" alt="Logo"/>
                            </div>
                            <div className="job-info">
                                <h5>{item.cargo}</h5>
                                <div className="job-detail">
                                    <i className="bi bi-briefcase"></i> <span>{item.empresa}</span>
                                </div>
                                <div className="job-detail">
                                    <i className="bi bi-map"></i><span>{item.ciudad}</span>
                                </div>
                                <div className="job-detail">
                                    <i className="bi bi-alarm"></i> <span>{item.modalidad}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default WorkSection;